import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap";
import * as Yup from "yup";
import Select from "react-select";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { get, post, put, uri } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import FileUpload from "components/FileUpload/FileUpload";
import DragAndDropComponent from "components/FileUploadDrag/DragAndDrop";

function AddProject() {
  const navigate = useNavigate();
  const { projId } = useParams();
  const [customers, setCustomers] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [fileUploaders, setFileUploaders] = useState([0]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [fetchedProjData, setFetchedProjData] = useState({
    projectName: "",
    customer: "",
    status: "",
    startDate: "",
    endDate: "",
    priority: "",
    budget: "",
    spentAmount: "",
    remainingBudget: "",
    projectDetailsId: "",
    projectTeamId: "",
    tags: "",
    comments: "",
    projectManager: "",
    teamMembers: [],
    roles: "",
    contactInfo: "",
    jiraURL: "",
    gitURL: "",
    projectDocuments: [], // Add projectDocuments to store fetched documents
  });

  useEffect(() => {
    async function doFetchCalls() {
      await fetchData();
      await fetchEmployeeData();
      if (projId) {
        fetchProjectData(projId);
      } else {
        setIsLoading(false);
      }
    }

    doFetchCalls();

    return () => {};
  }, [projId]);

  const fetchData = async () => {
    try {
      const customersData = await get(
        api.GET_ALL_CUSTOMERS_ID_NAME_MAIL_CURRENCY
      );
      console.log("customersData",customersData);
      
      const updatedCustData = customersData.map((item) => ({
        value: item.customerId,
        label: `${item.companyName}-   (${item.customerCode})`,
      }));
      setCustomers(updatedCustData);
    } catch (error) {
      console.log("Error fetching data");
    }
  };

  const fetchEmployeeData = async () => {
    try {
      const response = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = response.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
      }));
      setEmployee(employeeResponse);
    } catch (error) {
      console.log("Error fetching employee data");
    }
  };

  const fetchProjectData = async (projId) => {
    try {
      const response = await get(api.GET_PROJECT_BY_ID(projId));
      const projectData = response?.paginationResponse?.data[0];
      
      // Assuming projectData.projectDocuments contains an array of document objects
      // Example: [{ id: 1, name: "doc.pdf", path: "/uploads/doc.pdf" }, ...]
      const projectDocuments = projectData?.projectDocuments || [];

      // Initialize fileUploaders and uploadedFiles based on projectDocuments
      const initialUploaders = projectDocuments.length
        ? projectDocuments.map((_, index) => index)
        : [0];
      // const initialUploadedFiles = projectDocuments.reduce(
      //   (acc, doc, index) => {
      //     acc[index] = {
      //       id: doc.id,
      //       name: doc.name,
      //       path: doc.path,
      //     };
      //     return acc;
      //   },
      //   {}
      // );

    

      try {
      if (parseInt(projectDocuments[0])) {
        const fileResponse = await get(
          `${uri}/fileservice/api/files/view/${projectDocuments[0]}`
        );

        const initialUploadedFiles = {
          id: fileResponse.id,
          fileName: fileResponse.fileName,
          name: fileResponse.fileName,
        };
        setUploadedFiles(initialUploadedFiles);
      }

      setFileUploaders(initialUploaders);
    } catch (err) {
      console.log(err);
    }

    // console.log("projectData", projectData);
    // debugger

      setFetchedProjData({
        projectName: projectData?.projectName || "",
        customer: projectData?.customerId || "",
        status: projectData?.status || "",
        startDate: projectData?.projectDetailsTO?.startDate || "",
        endDate: projectData?.projectDetailsTO?.endDate || "",
        priority: projectData?.projectDetailsTO?.priority || "",
        budget: projectData?.projectDetailsTO?.budget || "",
        spentAmount: projectData?.projectDetailsTO?.spentAmount || "",
        remainingBudget: projectData?.projectDetailsTO?.remainingBudget || "",
        tags: projectData?.tags || "",
        comments: projectData?.comments || "",
        projectTeamId:
          projectData?.projectDetailsTO?.projectTeamTOList[0]?.projectTeamId ||
          "",
        projectDetailsId: projectData?.projectDetailsTO?.projectDetailsId || "",
        projectManager:
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]
            ?.projectManagerId || "",
        teamMembers:
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]
            ?.employeeIdList || [],
        roles:
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]?.roles || "",
        contactInfo:
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]
            ?.contactInformation || "",
        projectDocuments,
        jiraURL: projectData?.jiraUrl || "",
        gitURL: projectData?.gitHubUrl || "",

      });
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  // console.log("fetchedProjData", fetchedProjData);
  

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: fetchedProjData,
    validationSchema: Yup.object({
      projectName: Yup.string().required("Please enter project name"),
      customer: Yup.string().required("Please select customer name"),
      status: Yup.string().required("Please select status"),
      startDate: Yup.date().required("Please enter start date"),
      endDate: Yup.date()
        .required("Please enter end date")
        .min(Yup.ref("startDate"), "End date must be after start date"),
      priority: Yup.string().required("Please select priority"),
      budget: Yup.number()
        .required("Please enter budget")
        .positive("Budget must be positive"),
      spentAmount: Yup.number()
        .required("Please enter spent amount")
        .positive("Spent amount must be positive"),
      remainingBudget: Yup.number()
        .required("Please enter remaining budget")
        .positive("Remaining budget must be positive"),
      tags: Yup.string(),
      comments: Yup.string(),
      projectManager: Yup.string().required("Please select project manager"),
      teamMembers: Yup.array(),
      roles: Yup.string(),
      contactInfo: Yup.string(),
      jiraURL: Yup.string().url("Please enter a valid URL"),
      gitURL: Yup.string().url("Please enter a valid URL"),
    }),

    onSubmit: async (values) => {
 
   
      // console.log("file details", uploadedFiles);

      const payload = {
        projectDTO: {
          customerId: values.customer,
          subscriptionId: 100,
          projectName: values.projectName,
          comments: values.comments,
          status: values.status,
          isActive: 1,
          projectDocuments: [uploadedFiles?.id], // Send only IDs to backend
          jiraUrl: values.jiraURL,
          gitHubUrl: values.gitURL,
          projectDetailsTO: {
            startDate: values.startDate,
            endDate: values.endDate,
            priority: values.priority,
            budget: values.budget,
            spentAmount: values.spentAmount,
            remainingBudget: values.remainingBudget,
            projectTeamTOList: [
              {
                projectTeamId: fetchedProjData.projectTeamId || "",
                projectManagerId: values.projectManager,
                roles: values.roles,
                contactInformation: values.contactInfo,
                employeeIdList: values.teamMembers,
              },
            ],
          },
        },
      };

      try {
        if (projId) {
          const url = api.UPDATE_PROJECT_BY_ID(projId);
          const response = await put(url, payload);
          showSuccessToast("Project updated successfully");
          navigate("/projects");
        } else {
          const url = api.CREATE_PROJECT;
          const response = await post(url, payload);
          showSuccessToast("Project created successfully");
          navigate("/projects");
        }
      } catch (error) {
        console.error("Error saving project:", error);
        showErrorToast("Failed to save project");
      }
    },
  });

  const handleBudgetChange = (e) => {
    const budgetValue = parseFloat(e.target.value);
    validation.setFieldValue("budget", budgetValue);
    if (validation.values.spentAmount) {
      const remaining = budgetValue - validation.values.spentAmount;
      validation.setFieldValue(
        "remainingBudget",
        remaining >= 0 ? remaining : 0
      );
    }
  };

  const handleSpendAmountChange = (e) => {
    const spendAmountValue = parseFloat(e.target.value);
    validation.setFieldValue("spentAmount", spendAmountValue);
    if (validation.values.budget) {
      const remaining = validation.values.budget - spendAmountValue;
      validation.setFieldValue(
        "remainingBudget",
        remaining >= 0 ? remaining : 0
      );
    }
  };

  const handleFileUpload = (response) => {
    setUploadedFiles({ ...response, name: response.fileName });
  };

  const handleFileRemove = (uploaderId) => {
    setUploadedFiles((prev) => {
      const updated = { ...prev };
      delete updated[uploaderId];
      return updated;
    });
  };

  const addUploader = () => {
    setFileUploaders((prev) => [...prev, prev.length]);
  };

  const removeUploader = (id) => {
    setFileUploaders(fileUploaders.filter((uploaderId) => uploaderId !== id));
    handleFileRemove(id);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // console.log("fileUploaders",fileUploaders);
  // console.log("uploadedFiles",uploadedFiles);

  return (
    <div className="page-content">
      <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading={projId ? "Edit Project" : "Add Project"}
          routePath={"Home"}
          pageName={projId ? "Edit Project" : "Add Project"}
        />
        <Row className="p-4">
          <Col>
            <Card>
              <CardBody>
                <Form
                  className="row g-3 needs-validation py-0"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row className="card-group">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Project Information</p>
                    </Col>
                    <Row className="card-group-body">
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="customer">
                            Customer <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="customer"
                            type="select"
                            className="form-control"
                            id="customer"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.customer || ""}
                            invalid={
                              validation.touched.customer &&
                              validation.errors.customer
                            }
                            disabled={projId}
                          >
                            <option value="">Select</option>
                            {customers.map((item) => (
                              <option key={item.value} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.customer &&
                            validation.errors.customer && (
                              <FormFeedback type="invalid">
                                {validation.errors.customer}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="projectName">
                            Project Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="projectName"
                            type="text"
                            className="form-control"
                            id="projectName"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.projectName || ""}
                            invalid={
                              validation.touched.projectName &&
                              validation.errors.projectName
                            }
                          />
                          {validation.touched.projectName &&
                            validation.errors.projectName && (
                              <FormFeedback type="invalid">
                                {validation.errors.projectName}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="projectManager">
                            Project Manager{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="projectManager"
                            type="select"
                            className="form-control"
                            id="projectManager"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.projectManager || ""}
                            invalid={
                              validation.touched.projectManager &&
                              validation.errors.projectManager
                            }
                          >
                            <option value="">Select</option>
                            {employee.map((item) => (
                              <option key={item.value} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.projectManager &&
                            validation.errors.projectManager && (
                              <FormFeedback type="invalid">
                                {validation.errors.projectManager}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="teamMembers">Team</Label>
                          <Select
                            isMulti
                            name="teamMembers"
                            options={employee}
                            value={employee.filter((option) =>
                              validation.values.teamMembers.includes(
                                option.value
                              )
                            )}
                            onChange={(selected) => {
                              const selectedVal = selected
                                ? selected.map((item) => item.value)
                                : [];
                              validation.setFieldValue(
                                "teamMembers",
                                selectedVal
                              );
                            }}
                            onBlur={() => {
                              validation.setFieldTouched(
                                "teamMembers",
                                true,
                                true
                              );
                            }}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                          {validation.touched.teamMembers &&
                            validation.errors.teamMembers && (
                              <div className="custom-invalid">
                                {validation.errors.teamMembers}
                              </div>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="status">
                            Status <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="select"
                            name="status"
                            className="form-select"
                            id="status"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.status || ""}
                            invalid={
                              validation.touched.status &&
                              validation.errors.status
                            }
                          >
                            <option value="">Select</option>
                            <option value="YET_TO_START">Yet to Start</option>
                            <option value="IN_PROGRESS">In Progress</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="ON_HOLD">On Hold</option>
                            <option value="DELAYED">Delayed</option>
                          </Input>
                          {validation.touched.status &&
                            validation.errors.status && (
                              <FormFeedback type="invalid">
                                {validation.errors.status}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="jiraURL">Jira URL</Label>
                          <Input
                            name="jiraURL"
                            type="text"
                            className="form-control"
                            id="jiraURL"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.jiraURL}
                            invalid={
                              validation.touched.jiraURL &&
                              !!validation.errors.jiraURL
                            }
                          />
                          {validation.touched.jiraURL &&
                            validation.errors.jiraURL && (
                              <FormFeedback type="invalid">
                                {validation.errors.jiraURL}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="gitURL">GitHub URL</Label>
                          <Input
                            name="gitURL"
                            type="text"
                            className="form-control"
                            id="gitURL"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.gitURL}
                            invalid={
                              validation.touched.gitURL &&
                              !!validation.errors.gitURL
                            }
                          />
                          {validation.touched.gitURL &&
                            validation.errors.gitURL && (
                              <FormFeedback type="invalid">
                                {validation.errors.gitURL}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Row>
                  <Row className="card-group mt-3">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Project Details</p>
                    </Col>
                    <Col md="6">
                      <FormGroup className="my-3">
                        <Label htmlFor="startDate">
                          Start Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="startDate"
                          type="date"
                          className="form-control"
                          id="startDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.startDate || ""}
                          invalid={
                            validation.touched.startDate &&
                            validation.errors.startDate
                          }
                        />
                        {validation.touched.startDate &&
                          validation.errors.startDate && (
                            <FormFeedback type="invalid">
                              {validation.errors.startDate}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="my-3">
                        <Label htmlFor="endDate">
                          End Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="endDate"
                          type="date"
                          className="form-control"
                          id="endDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.endDate || ""}
                          invalid={
                            validation.touched.endDate &&
                            validation.errors.endDate
                          }
                        />
                        {validation.touched.endDate &&
                          validation.errors.endDate && (
                            <FormFeedback type="invalid">
                              {validation.errors.endDate}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="priority">
                          Priority <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="select"
                          name="priority"
                          className="form-select"
                          id="priority"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.priority || ""}
                          invalid={
                            validation.touched.priority &&
                            validation.errors.priority
                          }
                        >
                          <option value="">Select Priority</option>
                          <option value="LOW">Low</option>
                          <option value="MEDIUM">Medium</option>
                          <option value="HIGH">High</option>
                        </Input>
                        {validation.touched.priority &&
                          validation.errors.priority && (
                            <FormFeedback type="invalid">
                              {validation.errors.priority}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="budget">
                          Budget <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="budget"
                          type="text"
                          className="form-control"
                          id="budget"
                          onChange={handleBudgetChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.budget || ""}
                          invalid={
                            validation.touched.budget &&
                            validation.errors.budget
                          }
                        />
                        {validation.touched.budget &&
                          validation.errors.budget && (
                            <FormFeedback type="invalid">
                              {validation.errors.budget}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="spentAmount">
                          Spent Budget <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="spentAmount"
                          type="text"
                          className="form-control"
                          id="spentAmount"
                          onChange={handleSpendAmountChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.spentAmount || ""}
                          invalid={
                            validation.touched.spentAmount &&
                            validation.errors.spentAmount
                          }
                        />
                        {validation.touched.spentAmount &&
                          validation.errors.spentAmount && (
                            <FormFeedback type="invalid">
                              {validation.errors.spentAmount}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="remainingBudget">
                          Remaining Budget{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="remainingBudget"
                          type="text"
                          className="form-control"
                          id="remainingBudget"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.remainingBudget || ""}
                          invalid={
                            validation.touched.remainingBudget &&
                            validation.errors.remainingBudget
                          }
                          disabled={
                            validation.values.budget &&
                            validation.values.spentAmount
                          }
                        />
                        {validation.touched.remainingBudget &&
                          validation.errors.remainingBudget && (
                            <FormFeedback type="invalid">
                              {validation.errors.remainingBudget}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="comments">Project Description</Label>
                        <Input
                          name="comments"
                          type="textarea"
                          className="form-control"
                          id="comments"
                          rows={3}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.comments || ""}
                          invalid={
                            validation.touched.comments &&
                            validation.errors.comments
                          }
                        />
                        {validation.touched.comments &&
                          validation.errors.comments && (
                            <FormFeedback type="invalid">
                              {validation.errors.comments}
                            </FormFeedback>
                          )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="card-group mt-3 flex">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Project Documents</p>
                    </Col>
                    {/* {fileUploaders.map((uploaderId) => (
                      
                    ))} */}
                    <Col
                      md={3}
                      // key={uploaderId}
                    >
                      <div className="position-relative rounded py-2 pe-4">
                        <DragAndDropComponent
                          // handleFileUpload={handleFileUpload}
                          initialFile={uploadedFiles}
                          handleFileUpload={handleFileUpload}
                        />

                        {/* {uploadedFiles?.id && (
                          <button
                            type="button"
                            onClick={() => removeUploader(uploadedFiles.id)}
                            className="btn btn-outline-danger btn-sm"
                            style={{
                              fontSize: "1rem",
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                            }}
                          >
                            ×
                          </button>
                        )} */}
                      </div>
                    </Col>
                    {/* <Col xs={12} className="d-flex justify-content-end my-3">
                      <Button color="primary" onClick={addUploader}>
                        + Add Files
                      </Button>
                    </Col> */}
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer save={validation.handleSubmit} />
    </div>
  );
}

export default AddProject;
